module.exports = false;


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0